<template>
  <v-card>
    <v-card-title>
        <v-btn  
          round 
          color="success" 
          class="text-none"
          @click="gerarRelatorioExcelListaInscritos"
          v-if="usuarioPerfil.co_perfil === 777"
        >
          Gerar Relatório Excel
        </v-btn>
      <v-spacer />
      <v-text-field
        v-model="pesquisar"
        append-icon="search"
        label="Pesquisar"
        single-line
        hide-details
      />
      <v-spacer />
    </v-card-title>
    <v-card-text class="pa-0">
      <v-data-table
        :headers="headers_conselho"
        :items="habilitacaoConselhos"
        :pagination.sync="pagination_conselho"
        :total-items="totalItems"
        :loading="!habilitacaoConselhos.length"
        :search="pesquisar"
        item-key="co_conselho"
        class="elevation-1"
      >
        <template
          slot="items"
          slot-scope="props"
        >
          <td>{{ props.item.cnpj_formatado }}</td>
          <td>{{ props.item.no_conselho }}</td>
          <td>
            <v-chip
              dark
              color="primary"
            >
              {{ props.item.endereco.municipio.uf.no_uf }}
            </v-chip>
          </td>
          <td>
            <v-chip>
              {{ props.item.endereco.municipio.uf.regiao.no_regiao }}
            </v-chip>
          </td>
          <td>
                  <v-chip
                    dark
                    :color="colorStHabilitacao[parseInt(props.item.st_habilitacao)+1]"
                  >
                    {{ props.item.ds_habilitacao }}
                  </v-chip>
                </td>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'ConselhoLista',
  props: {
    souAdministrador: {
      source: {
        type: Boolean,
        default: false,
      },
    },
  },
  data: () => ({
    pesquisar: '',
    tipoModal: '',
    pagination_conselho: {
      page: 1,
      rowsPerPage: 10,
      sortBy: 'no_conselho',
      descending: false,
    },
    totalItems: 0,
    headers_conselho: [
        {
          text: 'CNPJ do órgão gestor do conselho',
          value: 'cnpj_formatado',
        },
        {
          text: 'Nome do conselho',
          value: 'no_conselho',
        },
        {
          text: 'UF',
          value: 'endereco.municipio.uf.no_uf',
        },
        {
          text: 'Região',
          value: 'endereco.municipio.uf.regiao.no_regiao',
        },
        {
          text: 'Resultado final da habilitação',
          value: 'ds_habilitacao',
        },
      ],
      colorStHabilitacao: [
        'warning',
        'error',
        'success',
      ],
  }),
  computed: {
    ...mapGetters({
      habilitacaoConselhos: 'conselho/habilitacaoConselhos',
      usuarioPerfil: 'conta/perfil',
    }),
  },
  methods: {
    ...mapActions({
      obterListaHabilitacao: 'conselho/obterListaParcialHabilitacao',
    }),
    gerarRelatorioExcelListaInscritos(){
      this.gerarRelatorioExcelListaInscritosAction();
    },
  },
  mounted() {
    this.obterListaHabilitacao();
  },
};
</script>
